import { useEffect, useState } from 'react';
import { ProjectApi, ToastStateHandler } from '../../../api';
import { ProjectRoleDto } from '../../../commonTypes/project.types';
import { useContainer } from '../../useContainer';
import { useTranslation } from '../../useTranslation';

const useHttpGetProjectRoles = (enabled: boolean = true) => {
    const { t } = useTranslation('newNotifications');
    const projectApi: ProjectApi = useContainer(ProjectApi);
    const [roles, setRoles] = useState<ProjectRoleDto[]>([]);
    const [areProjectRolesReady, setProjectRolesReady] = useState<boolean>(false);

    const toastHandler: ToastStateHandler = useContainer(ToastStateHandler);

    useEffect(() => {
        if (!enabled) {
            setProjectRolesReady(true);
            return;
        }

        const { exec, abort } = projectApi.getRolesFromProject({
            onSuccess: res => setRoles(res.body),
            onError: _ => toastHandler.push('error', t('common.error'), t('common.somethingWentWrong')),
            onFinally: () => setProjectRolesReady(true),
        });
        exec();
        return abort;
    }, [enabled]);

    return { roles, areProjectRolesReady };
};

export default useHttpGetProjectRoles;
